import { createRouter, createWebHistory } from "@ionic/vue-router";

import Home from "@/views/Home.vue";

import DetailProduct from "@/views/DetailProduct.vue";
import OrderPaymentQris from "@/views/OrderPaymentQris.vue";
import WaitingPage from "@/views/WaitingPage.vue";
import PaymentQrisPage from "@/views/PaymentQrisPage.vue";
import HomePage from "@/views/HomePage";

const routes = [
  {
    path: "/",
    // redirect: "/29",
    component: HomePage,
  },
  {
    path: "/:id",
    name: "home",
    component: Home,
  },
  {
    path: "/:id/:detail_id",
    name: "detailProduct",
    component: DetailProduct,
  },
  {
    path: "/:id/order/payment/qris",
    name: "orderPaymentQris",
    component: OrderPaymentQris,
  },
  {
    path: "/:id/order/payment/qris/waiting",
    name: "waitingPayment",
    component: WaitingPage,
  },
  {
    path: "/:id/order/payment/qris/code",
    name: "paymentQris",
    component: PaymentQrisPage,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
